import { includes } from 'lodash-es';

import { getConfig } from '../../config';
import { COUNTRY_DOMAINS } from '../constants';
const signUpLandingVariantCountries = [
  COUNTRY_DOMAINS.id,
  COUNTRY_DOMAINS.vn,
] as const;
export default function useIsSignUpLandingVariantEnabled() {
  const { COUNTRY } = getConfig();
  const isSignUpLandingVariantCountry = includes(
    signUpLandingVariantCountries,
    COUNTRY
  );
  return isSignUpLandingVariantCountry;
}
